import React, { useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { cdBizLnd } from 'data/configs';
import { toJS } from 'mobx';
import ComplexNewsCommonModel from 'common-modules/general/Common/Logic/News/NewsCommon';
import './style.scss';
import { RoutesString } from 'common-modules/general/Config/routesString';

const NewsDetail = observer(() => {
  const params = useLocation();
  const id = params.search.replace('?id=', '');
  const { model: mainModel } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));
  const history = useHistory();

  useEffect(() => {
    if (typeof id === 'string') {
      const changeIdType = Number(id);
      mainModel.getNewsDetailData(cdBizLnd, changeIdType);
    } else {
      mainModel.getNewsDetailData(cdBizLnd, id);
    }
  }, []);

  const detailNewsData = toJS(mainModel.detailData.data);

  if (mainModel.detailData.loadStatus === 'READY' && detailNewsData) {
    return (
      <div className="contents-news">
        <div className="border-container  medium mlr-auto mb-120">
          <div className="border-info-wrapper">
            <div className="info-form">
              <div className="title-form">
                <div className="title">{detailNewsData?.sbjtNtcPlte}</div>
                <div className="day">{detailNewsData?.dntRgst}</div>
              </div>
              <div className="section-form" dangerouslySetInnerHTML={{ __html: detailNewsData?.cntNtcPlteWhol || '' }}></div>
            </div>
          </div>
          <div className="infor-button" onClick={() => history.push(RoutesString.SalesNews)}>
            <p className="label">목록</p>
          </div>
        </div>
      </div>
    );
  } else if (mainModel.detailData.loadStatus === 'PENDING') {
    return <div style={{ height: '1000px' }}></div>;
  } else {
    return <Redirect to={RoutesString.SalesNews} />;
  }
});

export default NewsDetail;
